import { render, staticRenderFns } from "./FlickingCarousel.vue?vue&type=template&id=2d5796ce&scoped=true&"
import script from "./FlickingCarousel.vue?vue&type=script&lang=js&"
export * from "./FlickingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FlickingCarousel.vue?vue&type=style&index=0&id=2d5796ce&prod&lang=scss&scoped=true&"
import style1 from "./FlickingCarousel.vue?vue&type=style&index=1&id=2d5796ce&prod&lang=css&"
import style2 from "./FlickingCarousel.vue?vue&type=style&index=2&id=2d5796ce&prod&lang=scss&"
import style3 from "./FlickingCarousel.vue?vue&type=style&index=3&id=2d5796ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5796ce",
  null
  
)

export default component.exports